import styled from 'styled-components';
import { theme } from '../../styles/theme';
import { Pagination } from '@material-ui/lab';

const { mainColor, rbmWhite, rbmBlack } = theme.colors;

export const PaginationComponent = styled(Pagination)`
  margin: 1vw 0;
  display: flex;
  justify-content: center;

  .MuiPaginationItem-page {
    background-color: rgba(51, 51, 51, 0.1);
  }

  .MuiPaginationItem-page.Mui-selected {
    background-color: ${mainColor};
  }
`;
